document.querySelectorAll('.sidebar').forEach(sidebar => {
    const scrollTreshold = 60;
    const footer = document.querySelector('.footer');

    const update = () => {
        if (window.innerWidth < 1024) return;

        sidebar.classList.toggle('sidebar-fixed', window.scrollY > scrollTreshold);

        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight) {
            sidebar.style.bottom = (window.innerHeight - footerRect.top) + 'px';
        } else {
            sidebar.style.bottom = '0';
        }
    };

    const animate = () => {
        requestAnimationFrame(animate);
        update();
    };

    animate();

    window.addEventListener('scroll', update);

});